import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M8.23633 19.7577C8.62685 20.1483 9.26002 20.1483 9.65054 19.7577C10.0411 19.3672 10.0411 18.734 9.65054 18.3435L4.30491 12.9979L21.8907 12.9979C22.443 12.9979 22.8907 12.5502 22.8907 11.9979C22.8907 11.4456 22.443 10.9979 21.8907 10.9979L4.30507 10.9979L9.65054 5.65242C10.0411 5.26189 10.0411 4.62873 9.65054 4.23821C9.26002 3.84768 8.62685 3.84768 8.23633 4.23821L1.19429 11.2802C1.18711 11.2872 1.18002 11.2943 1.17305 11.3015L0.476562 11.998L8.23633 19.7577Z" })]
});
const ForwardRef = forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
